import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import CustomizeCard from '../Card/CustomizeCard'
import { device, getNetPrice, getTax } from '../../../utils/helpers'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { displayVariations, updateComponentList, updateCalculator } from '../../../actions/calculator'
import CloseIcon from '../../UI/Icons/CloseIcon'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  background: #E2E2E2;
  margin-bottom: 15px;
  padding: 0 15px;
  padding-bottom: 15px;

  @media ${device.tablet} {
    background: none;
    padding-bottom: 3.125vw;
    padding: 0;
  }

  ${'' /* @media ${device.laptop} {
    background: none;
    padding: 0;
  } */}
`

const Title = styled.div`
  padding: 13px 0;
  width: 100%;
  text-align: center;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 24px;

  @media ${device.tablet} {
  ${''/* 36,20, 10 */}
    font-size: 1.875vw;
    padding: 1.0416666666666667vw 0;
    margin-bottom: 0.5208333333333334vw;
    background-color: #fff;
    line-height: 1.1em;
  }
`

const Close = styled(CloseIcon)`
  position: absolute;
  top: 1px;
  right: 1px;

  @media ${device.tablet} {
    display: none;
  }
`

let CustomizeOptions = class CustomizeOptions extends Component {
  handleCloseClick () {
    // Blank array is set
    this.props.displayVariations()

    // To clear it for mobile
    let { components } = this.props
    // Remove anything that has type 5
    components.filter(component => component.type !== 5)
    this.props.updateComponentList(components)
  }

  handleCardClick (id) {
    const { options, components, step } = this.props
    let componentsCopy = [...components]
    const componentName = options[0].variation
    // Get the index of the component to update
    const index = _.findIndex(componentsCopy, { name: componentName })
    const selectedOption = _.find(options, { id })
    const updatedComponent = {
      name: componentName,
      price: selectedOption.amount,
      net: getNetPrice(selectedOption.amount),
      tax: getTax(selectedOption.amount),
      details: [selectedOption.name],
      type: selectedOption.display_type_id === 2 ? selectedOption.display_type_id : 4,
      selected: true,
      config_bit: selectedOption.config_bit,
      id: selectedOption.id
    }
    componentsCopy[index] = updatedComponent
    // Remove the type 5 object added for displaying the options in mobile
    componentsCopy = componentsCopy.filter(component => component.type !== 5)
    // Sum of all components price
    const totalPrice = _.reduce(componentsCopy,
      (sum, component) => component.selected && sum + component.price,
      0)
    // Data to update in step
    const data = {
      active: true,
      visited: true,
      price: totalPrice,
      net: getNetPrice(totalPrice),
      tax: getTax(totalPrice),
      components: componentsCopy
    }
    // Update step 3 of the calculator
    this.props.updateCalculator(step, data)
    // Update the list of components
    this.props.updateComponentList(componentsCopy)

    // Close the overlay on clicking the card
    // Blank array is set
    this.props.displayVariations()

    // // Remove anything that has type 5
    // components.filter(component => component.type !== 5)
    // this.props.updateComponentList(components)
  }

  // Returns true or false if card is selected
  isSelected (id) {
    const { options, components } = this.props
    if (options.length > 0) {
      // Get the name of the component who's options are being shown
      const componentName = options[0].variation
      // Get the index of the component
      const index = _.findIndex(components, { name: componentName })
      // Get the ID of the component
      const componentID = components[index].id
      // If ID of component matches the ID of the card then make it selected
      if (id === componentID) {
        return true
      } else {
        return false
      }
    }
    return false
  }

  render () {
    const { options } = this.props
    const orderedOptions = _.orderBy(options, ['amount'], ['asc'])
    return (
      options.length > 0 && <Wrapper {...this.props}>
        <Close
          width='15'
          fill='#4d4d4d'
          onClick={this.handleCloseClick.bind(this)}
        />
        <Title>
          Personalizza {options[0].variation}
        </Title>
        {orderedOptions.map(({ name, amount, id, img }) => (
          <CustomizeCard
            title={name}
            price={`+ ${amount} €`}
            image={`${process.env.PUBLIC_URL}/images/details-elements/${img}`}
            key={id}
            onClick={this.handleCardClick.bind(this, id)}
            selected={this.isSelected(id)}
          />
        ))}
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    options: state.calculator.options,
    components: state.calculator.components
  }
}

CustomizeOptions = withRouter(CustomizeOptions)

export default connect(mapStateToProps, { displayVariations, updateComponentList, updateCalculator })(CustomizeOptions)



// WEBPACK FOOTER //
// ./src/components/Calculator/Configurator/CustomizeOptions.js